export async function loadConfiguration(param: any) {
  //@ts-ignore
  const containerRef = window.containerRef;
  const canvasIframe = containerRef.current.contentWindow;
  const canvasCoords = await canvasIframe.LoadConfig(param);
 
  return canvasCoords;
}
